import store from '../store';
import { VESSEL_COLOUR_WHITE } from './vessel-constants.utils';
import { getUserVesselPreferenceColour } from './vessel-styling.utils';

export const isValidHexColor = (color: string | undefined | null): boolean =>
  !!color && /^#[0-9A-F]{6}$/i.test(color);

export const getFallbackColor = (): string => {
  const { userPreferences } = store.getState().userPreferences;
  const preferenceVesselColour = getUserVesselPreferenceColour(userPreferences);
  return preferenceVesselColour || VESSEL_COLOUR_WHITE;
};
